import createIcon from '../../createIcon';

/**
 * @component @name PhotoCameraBack
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNUMyMS4xIDUgMjIgNS45IDIyIDdWMTlDMjIgMjAuMSAyMS4xIDIxIDIwIDIxSDRDMi45IDIxIDIgMjAuMSAyIDE5VjdDMiA1LjkgMi45IDUgNCA1SDcuMTdMOSAzSDE1TDE2LjgzIDVIMjBaTTIwIDE5VjdINFYxOUgyMFpNMTQgMTJMMTEgMTUuNzJMOSAxM0w2IDE3SDE4TDE0IDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhotoCameraBack = createIcon('PhotoCameraBack', [
  [
    'path',
    {
      d: 'M20 5C21.1 5 22 5.9 22 7V19C22 20.1 21.1 21 20 21H4C2.9 21 2 20.1 2 19V7C2 5.9 2.9 5 4 5H7.17L9 3H15L16.83 5H20ZM20 19V7H4V19H20ZM14 12L11 15.72L9 13L6 17H18L14 12Z',
      key: 'vg3ayo',
    },
  ],
]);

export default PhotoCameraBack;
